import {
  Icon,
  type IconProps,
  Radio as SclRadio,
  type RadioProps as SclRadioProps,
} from '@ace-clublabs/shared-component-library';

interface RadioProps extends SclRadioProps {
  checkedIconName?: IconProps['iconName'];
}

const Radio: React.FC<RadioProps> = ({ checkedIconName, ...rest }) => (
  <SclRadio
    {...rest}
    checkedIcon={<Icon iconName={checkedIconName || 'circle-check-duotone'} />}
  />
);

export default Radio;
